export const processMenu = (prefix: string,menuPaths: string[]) => {
    return menuPaths.map((menuPath: string) => {
        return {
            name: menuPath.replace(prefix, ''),
            path: `${prefix}/${menuPath}`
        }
    })
}